import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { GENDER } from 'domains/product/constants'

/**
 * To give nice look in gender type by given seller type of the seller
 * @param {string} gender gender type. available value
 * - `female`
 * - `male`
 */
const ProductGenderBadge = ({ gender }) => {

  const colorMap = {
    [GENDER.FEMALE] : 'primary',
    [GENDER.MALE]   : 'warning'
  }

  const color = colorMap[gender] || 'default'

  return <StatusBadge color={ color } label={ gender } />
}

ProductGenderBadge.propTypes = {
  gender: PropTypes.string
}

export default ProductGenderBadge